import { useMemo } from 'react';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { Box, Container, Skeleton, Stack, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import CouponIcon from '../../components/icons/CouponIcon';
import AppButton from '../../components/ui/AppButton';
import { CouponStatus } from '../../constants/coupon';
import { useGetCouponList } from '../../hooks/useCompany';
import { useUserStore } from '../../stores/userStore';
import CouponCard from './components/CouponCard';

const MyCouponPage = () => {
  const companyInfo = useUserStore((state) => state.companyInfo);
  const { data: couponList, isPending } = useGetCouponList({
    page: 1,
    limit: 50,
    company_id: companyInfo?._id,
    enabled: !!companyInfo?._id,
  });

  const sortedCoupon = useMemo(() => {
    return couponList?.Data?.data?.sort((a, b) => {
      // sort by status waiting last
      if (a.status.toLowerCase() === CouponStatus.WAITING) return 1;
      if (b.status.toLowerCase() === CouponStatus.WAITING) return -1;
      return 0;
    });
  }, [couponList]);

  return (
    <Container maxWidth="md" sx={{ mx: 'auto', pt: 2, pb: 3 }}>
      {/* Back button */}
      <Link to={'/member'}>
        <AppButton
          variant="neutral"
          startIcon={<ArrowBackIosIcon />}
          sx={{ gap: 0, py: 0.5, px: 2 }}
        >
          กลับ
        </AppButton>
      </Link>

      {/* Title */}
      <Box
        sx={{
          my: 2,
          py: 0.75,
          backgroundColor: 'primary.main',
          borderRadius: '10px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 1,
        }}
      >
        <CouponIcon width={30} height={30} />
        <Typography component="h1" sx={{ fontSize: '1.5rem', fontWeight: 700, color: 'white' }}>
          คูปองของฉัน
        </Typography>
      </Box>

      {/* Coupons List */}
      {isPending && (
        <Stack spacing={1.5} sx={{ px: 0 }}>
          {Array.from({ length: 3 }).map((_, index) => (
            <Skeleton
              key={index}
              animation="wave"
              variant="rounded"
              width="100%"
              height={120}
              sx={{ borderRadius: '20px', backgroundColor: '#f7f7f7' }}
            />
          ))}
        </Stack>
      )}
      {!isPending && (
        <Stack spacing={1.5} sx={{ px: 0 }}>
          {sortedCoupon?.length > 0 ? (
            sortedCoupon?.map((coupon) => <CouponCard key={coupon._id} data={coupon} />)
          ) : (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                height: 100,
                backgroundColor: 'white',
                borderRadius: '10px',
                boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
              }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontWeight: 500,
                  fontSize: '1.5rem',
                  lineHeight: 1,
                }}
              >
                ยังไม่มีคูปอง
              </Typography>
            </Box>
          )}
        </Stack>
      )}
    </Container>
  );
};

export default MyCouponPage;
